// FILECONTENT_START src/common/components/DataGrid/row-buttons/ActionButtonRestore.tsx
import RestoreFromTrashIcon from "@mui/icons-material/RestoreFromTrash";
import I18n from "i18n-js";
import { DataGridActionButtonProps } from "../DataGrid";
import { GridActionsCellItem } from "../grid-imports";

export default function ActionButtonRestore({
  onClick,
  disabled,
}: DataGridActionButtonProps) {
  return (
    <GridActionsCellItem
      icon={<RestoreFromTrashIcon />}
      label={I18n.t("App.restore")}
      title={I18n.t("App.restore")}
      onClick={() => onClick && onClick()}
      disabled={disabled}
      //color="inherit"
    />
  );
}

// FILECONTENT_END src/common/components/DataGrid/row-buttons/ActionButtonRestore.tsx